<template>
  <div class="index-senior-component">
    <senior-list :list="seniorList" :item-click="itemClick"></senior-list>
  </div>
</template>

<script>
import SeniorList from '@/components/senior/SeniorList'
export default {
  components: {
    SeniorList
  },
  inheritAttrs: false,
  props: {
    seniorList: { type: Array, default: () => [] }
  },
  methods: {
    itemClick(item) {
      this.$stat({ key: 'index_senior_click', params: { o: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.index-senior-component {
  margin-bottom: 48px;
  overflow: hidden;
}
</style>
